import { createSlice, PayloadAction } from '@reduxjs/toolkit';

export interface IActivityFeedSearch {
  prevSearch: string | null;
}

const initialState: IActivityFeedSearch = {
  prevSearch: null,
};

export const activityFeedSearchSlice = createSlice({
  name: 'activityFeedSearch',
  initialState,
  reducers: {
    setPrevSearch: (state, action: PayloadAction<string>) => {
      state.prevSearch = action.payload;
    },
  },
});

export const { setPrevSearch } = activityFeedSearchSlice.actions;

export default activityFeedSearchSlice.reducer;
